var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LicensePlate',{attrs:{"link":_vm.link,"placeholder":_vm.placeholder,"append-query-string":_vm.appendQueryString}})
}
var staticRenderFns = []

export { render, staticRenderFns }